// extracted by mini-css-extract-plugin
export var header = "NewHeader-module--header--3bbf5";
export var headerHidden = "NewHeader-module--headerHidden--a1c9a";
export var menuModal = "NewHeader-module--menuModal--246c5";
export var menuModalBackdrop = "NewHeader-module--menuModalBackdrop--d3aa6";
export var menuModalBackdropHidden = "NewHeader-module--menuModalBackdropHidden--ebaad";
export var menuModalContent = "NewHeader-module--menuModalContent--7e4d7";
export var menuModalContent_detailLink = "NewHeader-module--menuModalContent_detailLink--c9689";
export var menuModalContent_detailList = "NewHeader-module--menuModalContent_detailList--28474";
export var menuModalContent_detailMain = "NewHeader-module--menuModalContent_detailMain--76ebf";
export var menuModalContent_detailSub = "NewHeader-module--menuModalContent_detailSub--d641f";
export var menuModalContent_icon = "NewHeader-module--menuModalContent_icon--041fe";
export var menuModalContent_iconDefs = "NewHeader-module--menuModalContent_iconDefs--4b4f3";
export var menuModalContent_iconIa = "NewHeader-module--menuModalContent_iconIa--51834";
export var menuModalContent_iconSub = "NewHeader-module--menuModalContent_iconSub--21c3d";
export var menuModalContent_iconSwap = "NewHeader-module--menuModalContent_iconSwap--26816";
export var menuModalContent_subtitle = "NewHeader-module--menuModalContent_subtitle--ffdc6";
export var menuModalContent_title = "NewHeader-module--menuModalContent_title--b5718";
export var menuModalContent_titleIa = "NewHeader-module--menuModalContent_titleIa--af325";
export var menuModalCtaButton = "NewHeader-module--menuModalCtaButton--3eddc";
export var menuModalCtaButtonPrimary = "NewHeader-module--menuModalCtaButtonPrimary--454cc";
export var menuModalCtaButtonSecondary = "NewHeader-module--menuModalCtaButtonSecondary--122e4";
export var menuModalCtaItem = "NewHeader-module--menuModalCtaItem--92959";
export var menuModalCtaList = "NewHeader-module--menuModalCtaList--2e2a1";
export var menuModalHidden = "NewHeader-module--menuModalHidden--d5d91";
export var navBar_detailLink = "NewHeader-module--navBar_detailLink--47673";
export var navBar_detailList = "NewHeader-module--navBar_detailList--a6b0a";
export var navBar_detailMain = "NewHeader-module--navBar_detailMain--147e2";
export var navBar_icon = "NewHeader-module--navBar_icon--bbc66";
export var navBar_iconIa = "NewHeader-module--navBar_iconIa--d78e8";
export var navBar_rootList = "NewHeader-module--navBar_rootList--5c3a5";
export var navBar_title = "NewHeader-module--navBar_title--f4c5f";
export var navBar_titleIa = "NewHeader-module--navBar_titleIa--9ac82";